export default "__VITE_ASSET__14v_$vpm__"